/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const VerifyMyEmailResponse = zod.object({
  attachedUnverified: zod
    .boolean()
    .optional()
    .describe(
      'True when the code completed a claim and the address is now on this account, but not verified. It cannot be made primary yet: verify it the ordinary way, starting with \/me\/emails\/resend.',
    ),
  emails: zod.array(
    zod.object({
      email: zod.email().describe('The email address'),
      primary: zod
        .boolean()
        .describe('True for the primary address (login\/JWT claim and profile email)'),
      verified: zod.boolean().describe('True once the address has passed OTP verification'),
    }),
  ),
});

export type VerifyMyEmailResponse = zod.input<typeof VerifyMyEmailResponse>;
export type VerifyMyEmailResponseOutput = zod.output<typeof VerifyMyEmailResponse>;
